import { SuperBonusValidBetTypes } from '@superbet-group/betting.lib.payments';
import { logger } from '@superbet-group/web.lib.utilities';

export function parseSuperAdvantageSports(superAdvantageSports?: string): number[] {
    if (!superAdvantageSports) {
        return [];
    }

    // Check if the string matches the pattern: numbers separated by commas
    if (!/^\d+(,\d+)*$/.test(superAdvantageSports)) {
        logger.error(new Error('Invalid superAdvantageSports format. Expected a string with numbers separated by commas.'));
        return [];
    }

    return superAdvantageSports.split(',').map((sportId) => Number(sportId.trim()));
}

function mapBetType(betTypeInput: string): SuperBonusValidBetTypes | null {
    const betType = betTypeInput.trim().toLowerCase();
    if (betType === SuperBonusValidBetTypes.System.toLowerCase()) {
        return SuperBonusValidBetTypes.System;
    } else if (betType === SuperBonusValidBetTypes.Simple.toLowerCase()) {
        return SuperBonusValidBetTypes.Simple;
    } else {
        return null;
    }
}

export function parseRemoteSuperBonusValidBetTypes(validBetTypes?: string): SuperBonusValidBetTypes[] {
    // for the case of misconfiguration or empty configuration
    const fallbackBetTypes = [
        SuperBonusValidBetTypes.Simple,
        SuperBonusValidBetTypes.System,
    ];

    if (!validBetTypes) {
        logger.warn('SuperBonus valid bet types are not configured. Using default value "simple|system"');
        return fallbackBetTypes;
    }

    const mappedBetTypes = validBetTypes.split('|')
        .map(mapBetType)
        .filter((betType): betType is SuperBonusValidBetTypes => betType !== null);

    if (mappedBetTypes.length === 0) {
        logger.error(new Error(`The SuperBonus valid bet types ${mappedBetTypes} are not supported. Using default value 'simple|system'`));
        return fallbackBetTypes;
    }

    return mappedBetTypes;
}
